import styled from 'styled-components';

export const ContainerIcon = styled.div`
  top: 5px;
  color: var(--bottom-color-sefaz);
  cursor: pointer;
  font-size: 2.6rem;
`;

export const IconButton = styled.div`
  cursor: pointer;
  font-size: 16pt;
  margin: 0 5px 0px 5px;
`;

export const ContainerSystem = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const ContainerSystemIcon = styled.div`
  margin: 5px;
  display: grid;
  max-height: 75px;
  justify-items: center;
  cursor: pointer;
`;

export const SystemImagem = styled.img`
  height: 50px;
`;
